import React, { ChangeEvent, useCallback } from 'react';
import styled from 'styled-components';
import FormControl from './FormControl';

type Props = {
  className?: string;
  label: React.ReactNode;
  error?: string;
  noHint?: boolean;
  hint?: string;
  onChange?(next: string): void;
} & Omit<
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >,
  'onChange'
>;

function Input({
  onChange,
  className,
  label,
  value,
  onFocus,
  onBlur,
  placeholder,
  noHint,
  hint,
  error,
  ...props
}: Props) {
  const handleChange = useCallback(
    ({ target: { value: nextValue } }: ChangeEvent<HTMLInputElement>) => {
      onChange?.(nextValue);
    },
    [onChange]
  );

  return (
    <FormControl
      label={label}
      error={error}
      value={value}
      onBlur={onBlur}
      onFocus={onFocus}
      className={className}
      required={props.required}
      hint={hint}
    >
      {({ floating, onBlur: handleBlur, onFocus: handleFocus }) => (
        <input
          {...props}
          placeholder={floating ? placeholder : undefined}
          onBlur={handleBlur}
          onFocus={handleFocus}
          onChange={handleChange}
          value={value}
        />
      )}
    </FormControl>
  );
}

export default styled(Input)`
  input {
    width: 100%;
    border: none;
    border-bottom: 1px solid #8a8a8a;
    border-radius: 0px;
    background: transparent;
    /* line-height: 1em; */
    padding: 6px 0px;
    box-sizing: border-box;
    outline: none;
  }

  input[readonly],
  input[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
    & ~ .label {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`;
